import { css, unsafeCSS } from "lit";

export const cssCardGrid = ({
  className = "cardGrid",
  gap = "30px",
  columnCount = 2,
  itemMinWidth = "300px",
}: { className?: string; gap?: string; columnCount?: number | string; itemMinWidth?: string } = {}) => css`
  .${unsafeCSS(className)} {
    --grid-layout-gap: ${unsafeCSS(gap)};
    --grid-column-count: ${unsafeCSS(columnCount)};
    --grid-item--min-width: ${unsafeCSS(itemMinWidth)};

    --gap-count: calc(var(--grid-column-count) - 1);
    --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
    --grid-item--max-width: calc((100% - var(--total-gap-width)) / var(--grid-column-count));

    display: grid;
    grid-template-columns: repeat(
      auto-fill,
      minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
    );
    grid-gap: var(--grid-layout-gap);
    grid-auto-rows: 1fr; /* make all the rows the same height */
  }
`;
